export default __webpack_public_path__ + "static/media/02_photo.93dc97b4.jpg";